// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { inputBaseClasses } from '@mui/material/InputBase';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { selectClasses } from '@mui/material/Select';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { borderRadius } from '../../tokens/spacing';
import { CaratDownIcon } from '../icons';
import { selectBoxColors } from './selectBoxColors';
export var Select = function(mode) {
    var c = selectBoxColors(mode);
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5;
    var override = {
        MuiSelect: {
            styleOverrides: {
                root: (_obj5 = {
                    padding: 0,
                    backgroundColor: c.default.background,
                    color: c.default.text,
                    borderRadius: rem(borderRadius.tiny),
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    minHeight: rem(36)
                }, _define_property(_obj5, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.default.border,
                    borderRadius: rem(borderRadius.tiny)
                }), _define_property(_obj5, "& .".concat(selectClasses.icon), {
                    top: 'auto',
                    width: rem(16),
                    height: rem(16),
                    right: rem(12)
                }), _define_property(_obj5, "& .".concat(svgIconClasses.root), {
                    color: c.default.icon
                }), _define_property(_obj5, '&:hover', (_obj = {
                    backgroundColor: c.hover.background
                }, _define_property(_obj, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.hover.border
                }), _define_property(_obj, "& .".concat(svgIconClasses.root), {
                    color: c.hover.icon
                }), _obj)), _define_property(_obj5, "&.".concat(outlinedInputClasses.focused), (_obj1 = {}, _define_property(_obj1, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.active.border,
                    borderWidth: 1
                }), _define_property(_obj1, "& .".concat(svgIconClasses.root), {
                    color: c.active.icon
                }), _obj1)), _define_property(_obj5, "&.".concat(outlinedInputClasses.disabled), (_obj2 = {
                    backgroundColor: c.disabled.background,
                    color: c.disabled.text
                }, // MUI's own disabled styles set notchedOutline's border-color to
                // rgba(0,0,0,0.26), overriding the base rule above at equal
                // specificity by cascade order — restate the theme token explicitly.
                _define_property(_obj2, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.disabled.border
                }), _define_property(_obj2, "& .".concat(svgIconClasses.root), {
                    color: c.disabled.icon
                }), _obj2)), _define_property(_obj5, "&.".concat(inputBaseClasses.readOnly), (_obj3 = {
                    color: c.readonly.text
                }, _define_property(_obj3, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.readonly.border
                }), _define_property(_obj3, "& .".concat(svgIconClasses.root), {
                    color: c.readonly.icon
                }), _obj3)), _define_property(_obj5, "&.".concat(outlinedInputClasses.error), (_obj4 = {}, _define_property(_obj4, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.error.border
                }), _define_property(_obj4, '&:hover', _define_property({
                    backgroundColor: c.hover.background
                }, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.error.border
                })), _define_property(_obj4, "&.".concat(outlinedInputClasses.focused), _define_property({}, "& .".concat(outlinedInputClasses.notchedOutline), {
                    borderColor: c.error.border,
                    borderWidth: 1
                })), _obj4)), _define_property(_obj5, "&.".concat(outlinedInputClasses.sizeSmall), _define_property({
                    padding: 0,
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    minHeight: rem(28)
                }, "& .".concat(selectClasses.icon), {
                    width: rem(12),
                    height: rem(12),
                    right: rem(6)
                })), _obj5),
                select: // Small: 4px vertical, 6px left, 24px right (12px icon + 6px gap + 6px).
                _define_property({
                    // MUI uses a compound-class selector (`.MuiSelect-select.MuiSelect-select`)
                    // that forces `padding-right: 32px`; `&&` boosts specificity to win.
                    // Medium: 8px vertical, 12px left, 36px right (16px icon + 8px gap + 12px).
                    '&&': {
                        padding: "".concat(rem(8), " ").concat(rem(36), " ").concat(rem(8), " ").concat(rem(12))
                    }
                }, "&&.".concat(outlinedInputClasses.inputSizeSmall), {
                    padding: "".concat(rem(4), " ").concat(rem(24), " ").concat(rem(4), " ").concat(rem(6))
                })
            },
            defaultProps: {
                IconComponent: CaratDownIcon
            }
        }
    };
    return override;
};

//# sourceMappingURL=Select.js.map